/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useReducer } from "react";
import { Image, Row, Col, Alert } from "react-bootstrap";
import VKservice from "../services/VKservice";
import VKcontext from "../context/VKcontext";
import { Spinner, Button } from "react-bootstrap";
import { initialState, photoReducer } from "../store/contentReducer";

const Content = () => {
  const vk = new VKservice();
  const [state, dispatch] = useReducer(photoReducer, initialState);
  const { active, setModalShow, setImage, token } = useContext(VKcontext);
  const offset = state.photos.length;
  useEffect(() => {
    loadPhoto(active);
  }, [active]);
  const loadPhoto = async id => {
    await dispatch({ type: "FETCH_PHOTOS" });
    const res = await vk.getPhotos(id, token);
    if (!res) {
      await dispatch({ type: "PHOTOS_ERROR" });
    } else {
      await dispatch({ type: "PHOTOS_LOADED", payload: res });
    }
  };

  const choosePhoto = url => {
    setImage(url);
    setModalShow(true);
  };
  const loadMorePhotos = async () => {
    console.log("OFFSET", offset);
    const res = await vk.getPhotos(active, token, offset);
    await dispatch({ type: "LOAD_MORE_PHOTOS", payload: res.items });
  };

  if (state.error) {
    return <Alert variant='danger' className='alertt mt-2'>Пользователь заблокирован</Alert>;
  }

  if (!active) {
    return null
  }
  if (state.loading) {
    return <Spinner animation="border" className="mt2 spinner" />;
  }

  const loadMore =
    offset < state.count ? (
      <Button className="load-more mt2 mb-2" onClick={loadMorePhotos}>
        Загрузить ещё
      </Button>
    ) : null;

  console.log("PHOTOS", state.photos, "OFFSET", offset, "COUNT", state.count);

  return (
    <Row>
      {state.photos.map(item => {
        return (
          <Col xs={2} md={2} key={item.id}>
            <Image
              src={item.photo_604}
              alt="img"
              onClick={() => choosePhoto(item.photo_604)}
            />
          </Col>
        );
      })}
      {loadMore}
    </Row>
  );
};

export default Content;
